import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";

export const getShowAmexBanner = (): boolean => {
  return getGlobalProperty("showAmexBanner") ?? false;
};
